"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collector = void 0;
const CardType_1 = require("../../cards/CardType");
class Collector {
    constructor() {
        this.name = 'Collector';
        this.description = 'Have at least 3 sets of automated, active and event cards';
    }
    getScore(player) {
        const numAutomatedCards = player.playedCards.filter((card) => card.cardType === CardType_1.CardType.AUTOMATED).length;
        const numActiveCards = player.playedCards.filter((card) => card.cardType === CardType_1.CardType.ACTIVE).length;
        const numEventCards = player.getPlayedEventsCount();
        return Math.min(numAutomatedCards, numActiveCards, numEventCards);
    }
    canClaim(player) {
        return this.getScore(player) >= 3;
    }
}
exports.Collector = Collector;
//# sourceMappingURL=Collector.js.map